import { createSelector } from '@reduxjs/toolkit';
import format from 'date-fns/format';
import { dcpcApi } from './dcpcApi';

const CHANNEL_MESSAGES_TAG = 'CHANNEL_MESSAGES';
const CHANNEL_INSTANCE_TAG = 'CHANNEL_MESSAGES';
const CHANNELS_TAG = 'CHANNELSMessages';

dcpcApi.enhanceEndpoints({ addTagTypes: [CHANNEL_MESSAGES_TAG, CHANNEL_INSTANCE_TAG] });
const channelMessagesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getChannelMessages: builder.query({
      query: () => ({
        method: 'GET',
        url: 'a/messagechannel',
      }),
      providesTags: [CHANNEL_MESSAGES_TAG],
    }),
    getChannelMessage: builder.query({
      query: (id) => `a/messagechannel/${id}`,
      providesTags: [CHANNEL_MESSAGES_TAG],
    }),

    updateChannelMessages: builder.mutation({
      query: (args) => ({
        method: args.id ? 'PUT' : 'POST',
        url: `a/messagechannel/${args.id || ''}`,
        body: args,
      }),
      invalidatesTags: [CHANNEL_MESSAGES_TAG],
    }),

    deleteChannelMessages: builder.mutation({
      query: (id) => ({
        method: 'DELETE',
        url: `a/messagechannel/${id || ''}`,
      }),
      invalidatesTags: [CHANNEL_MESSAGES_TAG],
    }),

    getChannelsTypes: builder.query({
      query: () => ({
        url: 'a/messagechannel/types',
        method: 'get',
      }),
      // providesTags: [CHANNEL_MESSAGES_TAG],
    }),

    // TODO: хз где это должно быть (была такая штука)
    // HTTPInstance(
    // { method: 'GET', createUrl: () =>
    // `a/messagechanneldata/find?channelId=${id}&startDate=${format(new Date(date.start), 'dd.MM.yyyy')}&endDate=${format(new Date(date.end), 'dd.MM.yyyy')}`
    // });
    getChannelMessageData: builder.query({
      query: (args) => ({
        method: 'GET',
        url: `a/messagechanneldata/find?channelId=${args.id}&startDate=${args.start}&endDate=${args.end}`,
      }),
      transformResponse: (result) => result.reduce((acc, item) => {
        acc.push({ x: format(new Date(item.receiveDate), 'dd.MM.yyyy'), y: item.dataSize });
        return acc;
      }, []),
      // providesTags: [CHANNEL_MESSAGES_TAG],
    }),

    getChannelInstance: builder.query({
      query: () => ({
        method: 'GET',
        url: 'a/channelInstance',
      }),
      providesTags: [CHANNEL_INSTANCE_TAG],
    }),

    updateChannelInstance: builder.mutation({
      query: (args) => ({
        method: 'GET',
        url: `a/channelInstance/${args.id}/${args.status}`,
      }),
      invalidatesTags: [CHANNEL_INSTANCE_TAG],
    }),

    getChannels: builder.query({
      query: () => ({
        method: 'GET',
        url: 'channels',
      }),
      providesTags: [CHANNELS_TAG],
    }),

  }),
});

export const {
  useGetChannelMessagesQuery,
  useGetChannelMessageQuery,
  useUpdateChannelMessagesMutation,
  useDeleteChannelMessagesMutation,
  useLazyGetChannelMessageDataQuery,
  useGetChannelsTypesQuery,
  useGetChannelInstanceQuery,
  useUpdateChannelInstanceMutation,

  useGetChannelsQuery,
} = channelMessagesApi;

export const channelTypesSelect = (state) => channelMessagesApi.endpoints.getChannelTypes.select()(state);
export const channelTypesSelector = (state) => channelTypesSelect(state).data || [];

const filterChannelsBySearchTextSelector = createSelector(
  channelTypesSelector,
  (_, searchText) => searchText,
  (channelTypes, searchText) => ({
    columns: [
      {
        label: 'Название канала',
      },

    ],
    rows: channelTypes.reduce((acc, cur) => {
      const row = [Math.random(), cur].map((v) => v || '');
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
  }),
);
export const channelTypesBySearchIdSelector = (searchText) => (state) => filterChannelsBySearchTextSelector(state, searchText);
